import * as React from 'react';
import { useTheme } from '@mui/material/styles';

import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import Bs4GenericField from './Bs4GenericField'
import Bs4Kartoteka from '../../Bs4Kartoteka';
import Bs4MainDispatch from '../../Bs4MainDispatch';
import Bs4Stores from '../../Bs4Stores';
import {Bs4Icon, getBs4Icon} from '../../Bs4Components/Bs4Icon'

const ICONS = 'fa-solid fa-icons'

export default class Bs4Button extends Bs4GenericField {  

  initializeFormField() {
    super.initializeFormField()
    this.bs4StoreIdName = Bs4Stores.getBs4Store(this.props.field.bs4store);    

    if (this.isParamSelected('ATRYB_PROGRESSBAR')) {
      console.log('...ATRYB_PROGRESSBAR...', this)
    }
  }

  hesValue() {return false;}

  startAtrybProgressbar = () => {
    if (!this.isParamSelected('ATRYB_PROGRESSBAR')) return;
    const bs4kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    bs4kartoteka.atrybProgressbar({
      field: this.props.field,
      optionId: this.optionId,
    });
  }

  ViewComponentField = (props) => {
    const formField = this;
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [loading, setLoading] = React.useState(false);
    this.refFocus = React.useRef();

    //if (!this.props.field.iconCls) this.props.field.iconCls = ICONS;
    
    const handleClickOpenMenu = (event, ref) => {
      //console.log('... OpenMenu ...', event, ref)
      //setAnchorEl(event.currentTarget);
      setAnchorEl(ref.current);
    };

    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    const getOffsetTime = React.useCallback((event) => {
      
    }, [props]);

    const handleClickButton = React.useCallback((e, autoclick) => {
      if (Bs4MainDispatch.isCommandParserWaitForServer()) {
        return;
      }
      this.startAtrybProgressbar();
      const bs4Kartoteka = Bs4Kartoteka.get(this.props.bs4KartotekaId);
      const bs4Option = bs4Kartoteka.getBs4Option(this.props.optionId);
      // 972 – Nr 49584 - Niezapisane zmiany a przycisk typu "Link do strony programu" [Core]
      const run = () => {
        setLoading(true);
        bs4Option?.bs4Form.atrybOnchange(this.props.field.formId, 'Bs4FormFieldValue' , null, () => setLoading(false), autoclick);
      }      
      if (parseInt(this.props.field.checkBs4Dirty) === 1) bs4Kartoteka.canBs4FormFieldValue(run);
      else run();
    }, [this.props.field.formId, this.props.bs4KartotekaId, this.props.optionId]);

    const handleClickButtonMenu = (item) => {
      if (Bs4MainDispatch.isCommandParserWaitForServer()) return;
      this.startAtrybProgressbar();
      const bs4Kartoteka = Bs4Kartoteka.get(this.props.bs4KartotekaId);
      const bs4Option = bs4Kartoteka.getBs4Option(this.props.optionId);
      // 972 – Nr 49584 - Niezapisane zmiany a przycisk typu "Link do strony programu" [Core]
      const run = () => {
        setLoading(true);
        bs4Option?.bs4Form.atrybOnchange(this.props.field.formId, 'Bs4FormFieldValue', item.id, () => setLoading(false));
      }      
      if (parseInt(this.props.field.checkBs4Dirty) === 1) bs4Kartoteka.canBs4FormFieldValue(run);
      else run();
      console.log('=i= Button Click Menu', item)              
      handleCloseMenu();
    }

    React.useEffect(() => {            
      let intervalAutoClick = null;
      const reloadEvery = parseInt(this.props?.field?.reloadEvery);
      if (reloadEvery > 0) {
        intervalAutoClick = setInterval(() => {
          try {
            console.log('...Bs4Button autoclick !!!', this.getLabelPlane())
            handleClickButton(null, true)
          } catch(error) {
            console.log('...Bs4Button clearInterval ...', intervalAutoClick, error)
            clearInterval(intervalAutoClick);      
          }            
        }, reloadEvery * 1000);
      }

      return () => {
        //console.log('... Bs4Button unmount ...', intervalFetchMore, report);
        clearInterval(intervalAutoClick);
      }
    }, [handleClickButton, this.props?.field?.reloadEvery])
    const sxStartIcon = formField.props.field.hideLabel ? {'.MuiButton-startIcon': {margin: 0}} : null;
    const label = formField.props.field.hideLabel ? null : <div dangerouslySetInnerHTML={{__html:this.getLabelPlane()}}/>;

    const button = (
      <Button  
        ref={this.refFocus}
        sx={{my:0.5, ...sxStartIcon}} 
        onClick={handleClickButton} 
        startIcon={getBs4Icon({iconCls: this.props.field?.iconCls, iconStyle: this.props.field?.iconStyle})}
        disabled={this.readOnly}
        loading={loading}
      >
        {label}
      </Button>
    );    

    const buttonMenu = () => {
      if (this.value) return (
        <ButtonGroup 
          ref={this.refFocus} 
          sx={{my:0.5}} 
          disabled={ this.readOnly}
        >
          <Button             
            onClick={handleClickButton} 
            sx={{...sxStartIcon}} 
            startIcon={getBs4Icon({iconCls: this.props.field?.iconCls, iconStyle: this.props.field?.iconStyle})}
            disabled={this.readOnly}
            loading={loading}
          >
            {label}
          </Button>
          <Button 
            onClick={(event) => handleClickOpenMenu(event, this.refFocus)}
            disabled={this.readOnly}
            loading={loading}
          >
            <KeyboardArrowDownIcon/>
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu} variant='menu'>
            {this.bs4StoreIdName.map(item => (
              item.text == '-------' 
              ?
              <Divider key={item.id}/>
              :
              <MenuItem key={item.id} onClick={() => handleClickButtonMenu(item)}>
                <ListItemIcon><Bs4Icon iconCls={item?.iconCls} iconStyle={item?.iconStyle}/></ListItemIcon>                
                <ListItemText>{item.name}</ListItemText>            
              </MenuItem>
            ))}
          </Menu>
        </ButtonGroup>
      );

      return (
        <React.Fragment>
          <Button 
            ref={this.refFocus}             
            onClick={(event) => handleClickOpenMenu(event, this.refFocus)}
            sx={{...sxStartIcon}}
            startIcon={getBs4Icon({iconCls: this.props.field?.iconCls, iconStyle: this.props.field?.iconStyle})}
            disabled={this.readOnly}
            loading={loading}
          >            
            {label}
            <KeyboardArrowDownIcon/>
          </Button>
          <Menu anchorEl={anchorEl} open={open} onClose={handleCloseMenu} variant='menu'>
            {this.bs4StoreIdName.map(item => (
              item.text == '-------' 
              ?
              <Divider key={item.id}/>
              :
              <MenuItem key={item.id} onClick={() => handleClickButtonMenu(item)}>
                <ListItemIcon><Bs4Icon iconCls={item?.iconCls} iconStyle={item?.iconStyle}/></ListItemIcon>
                <ListItemText>{item.name}</ListItemText>            
              </MenuItem>
            ))}
          </Menu>
        </React.Fragment>
      )
    }

    return (
      <Tooltip
        arrow
        placement='top'
        title={ formField.props.field?.tooltip}
        disableFocusListener={!Boolean(formField.props.field?.tooltip)}
        disableHoverListener={!Boolean(formField.props.field?.tooltip)}
      >
        {this.bs4StoreIdName?.length > 0 
          ? buttonMenu()
          : button
        } 
      </Tooltip>
    )    
  }
}